import { Request } from '../../../../generic/v2/request/request';
import { ConversationRequestNameType } from '../../../conversation-request-name';

export abstract class ConversationRequest extends Request<ConversationRequestNameType> {}
